import { FC } from 'react';
import Switch from '@mui/material/Switch';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { IGridActionSwitchProps } from './GridActionSwitch.interface';

export const GridActionSwitch: FC<IGridActionSwitchProps> = ({ checked, disabled, loading, onChange }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', height: '100%', gap: 0.5 }}>
    <Switch
      size={'small'}
      checked={checked}
      disabled={disabled || loading}
      onChange={(_, checked) => onChange?.(checked)}
    />
    {loading && <CircularProgress size={16} />}
  </Box>
);
